export default __webpack_public_path__ + "static/media/MrMillet.4d0f3c4c.jpeg";